import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const updateSubChannel = createAsyncThunk("updateSubChannel", async ({ channel_id, subchannel_id, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`channel/${channel_id}/sub_channel/${subchannel_id}`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const UpdateSubChannelSlice = createSlice({
	name: "UpdateSubChannelSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetUpdateSubChannelState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateSubChannel.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateSubChannel.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateSubChannel.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateSubChannelState } = UpdateSubChannelSlice.actions;
export default UpdateSubChannelSlice.reducer;
